import axios from 'axios';
import { getItem } from '../../utility/localStorageControl';
import Cookies from 'js-cookie';

const API_ENDPOINT = `${process.env.REACT_APP_API_ENDPOINT}`;
const API_SECURITY_TOKEN = `${process.env.REACT_APP_API_SECURITY_TOKEN}`;

const authHeader = () => ({
  Authorization: `Bearer ${getItem('onboarding_access_token') || getItem('access_token')}`,
});

const client = axios.create({
  baseURL: API_ENDPOINT,
  headers: {
    Authorization: `Bearer ${getItem('access_token')}`,
    'Content-Type': 'application/json',
    'X-Frame-Options':'SAMEORIGIN',// For Security added DENY OR SAMEORIGIN
    'Api-key' : API_SECURITY_TOKEN
  },
});

class DataService {
  static get(path = '') {
    return client({
      method: 'GET',
      url: path,
      headers: { ...authHeader() },
    });
  }

  static post(path = '', data = {}, optionalHeader = {}) {
    return client({
      method: 'POST',
      url: path,
      data,
      headers: { ...authHeader(), ...optionalHeader },
    });
  }

  static patch(path = '', data = {}) {
    return client({
      method: 'PATCH',
      url: path,
      data: JSON.stringify(data),
      headers: { ...authHeader() },
    });
  }

  static put(path = '', data = {}) {
    return client({
      method: 'PUT',
      url: path,
      data: JSON.stringify(data),
      headers: { ...authHeader() },
    });
  }

  static delete(path = '', data = {}) {
    return client({
      method: 'DELETE',
      url: path,
      data,
      headers: { ...authHeader() },
    });
  }
  static export(path = '', data = {}, optionalHeader = {}) {
    return client({
      method: 'POST',
      responseType: 'blob',
      url: path,
      data,
      headers: { ...authHeader(), ...optionalHeader },
    });
  }
}

/**
 * axios interceptors runs before and after a request, letting the developer modify req,req more
 * For more details on axios interceptor see https://github.com/axios/axios#interceptors
 */
client.interceptors.request.use((config) => {
  // do something before executing the request
  // For example tag along the bearer access token to request header or set a cookie
  const requestConfig = config;
  const { headers } = config;
  requestConfig.headers = { ...headers, Authorization: `Bearer ${getItem('onboarding_access_token') || getItem('access_token')}` };

  return requestConfig;
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    /**
     * Do something in case the response returns an error code [3**, 4**, 5**] etc
     * For example, on token expiration retrieve a new access token, retry a failed request etc
     */
    const { response } = error;
    // token expired then logout
    if(response?.data?.message === "Unauthenticated."){
      // redirect to login and clear cache::
      Cookies.remove('logedIn');
      Cookies.remove('access_token');
      Cookies.remove('onboarding_access_token');
      localStorage.removeItem('user');
      localStorage.removeItem('permissions');
      window.location.reload();
    }
    // const originalRequest = error.config;
    if (response) {
      // For other types of responses, return the original request
      return response;
    }
    return Promise.reject(error);
  },
);
export { DataService };
